module.exports = __webpack_public_path__ + "images/rb-color-picker.0fc36b2.png";